// extracted by mini-css-extract-plugin
module.exports = {"closeWhatIsTopcoderVideoCross":"_3HjNSl","whatIsTopcoderVideo":"_3iOAMW","watchVideoButton":"_11ZocD"};